import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import ExercisesPage from './pages/ExercisesPage';
import ClientsPage from './pages/ClientsPage';
import WorkoutPage from './pages/WorkoutPage';
import WorkoutsPage from './pages/WorkoutsPage';
import TemplatesPage from './pages/TemplatesPage';
import PackagesPage from './pages/PackagesPage';
import SettingsPage from './pages/SettingsPage';
import LogsPage from './pages/LogsPage';
import AdminPage from './pages/AdminPage';
import SharedExercises from './pages/SharedExercises';
import ClientStatsPage from './pages/ClientStatsPage';
import ClientNutritionPage from './pages/ClientNutritionPage';
import PrivateRoute from './components/PrivateRoute';

// Создаем клиента React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="App">
          <Routes>
            {/* Публичные маршруты */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/shared-exercises/:shareToken" element={<SharedExercises />} />
            
            {/* Защищенные маршруты */}
            <Route 
              path="/dashboard" 
              element={
                <PrivateRoute>
                  <DashboardPage />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/exercises" 
              element={
                <PrivateRoute>
                  <ExercisesPage />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/clients" 
              element={
                <PrivateRoute>
                  <ClientsPage />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/workouts" 
              element={
                <PrivateRoute>
                  <WorkoutsPage />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/workouts/:id" 
              element={
                <PrivateRoute>
                  <WorkoutPage />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/templates" 
              element={
                <PrivateRoute>
                  <TemplatesPage />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/packages" 
              element={
                <PrivateRoute>
                  <PackagesPage />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/settings" 
              element={
                <PrivateRoute>
                  <SettingsPage />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/logs" 
              element={
                <PrivateRoute>
                  <LogsPage />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/admin" 
              element={
                <PrivateRoute>
                  <AdminPage />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/clients/:clientId/stats" 
              element={
                <PrivateRoute>
                  <ClientStatsPage />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/clients/:clientId/nutrition" 
              element={
                <PrivateRoute>
                  <ClientNutritionPage />
                </PrivateRoute>
              } 
            />
            
            {/* Перенаправление на дашборд по умолчанию */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            
            {/* 404 страница */}
            <Route 
              path="*" 
              element={
                <div className="min-h-screen flex items-center justify-center bg-gray-50">
                  <div className="text-center">
                    <h1 className="text-6xl font-bold text-gray-900">404</h1>
                    <p className="text-xl text-gray-600 mt-4">Страница не найдена</p>
                    <a 
                      href="/" 
                      className="mt-6 inline-block bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700"
                    >
                      На главную
                    </a>
                  </div>
                </div>
              } 
            />
          </Routes>
          
          <Toaster
            position="bottom-center"
            toastOptions={{
              duration: 2000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                style: {
                  background: '#10b981',
                },
              },
              error: {
                style: {
                  background: '#ef4444',
                },
              },
            }}
          />
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App; 